module.exports = __webpack_public_path__ + "fonts/NotoSans-BoldItalic.f6eb3bf7.woff";